import api from '@/lib/api';

const upload = (url, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(url, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const justoAPI = {
  config: () => api.get('/justo/config'),
  updateConfig: (data) => api.put('/justo/config', data),
  subirPlantilla: (file) => upload('/justo/plantilla', file),
  descargarPlantilla: () => api.get('/justo/plantilla/descargar', { responseType: 'blob' }),
  destinos: () => api.get('/justo/destinos'),
  guardarSugerencias: () => api.post('/justo/destinos/guardar-sugerencias'),
  updateDestino: (locationId, lugar_codigo) => api.put(`/justo/destinos/${locationId}`, { lugar_codigo }),
  equivalencias: () => api.get('/justo/equivalencias'),
  updateEquivalencia: (itemId, data) => api.put(`/justo/equivalencias/${itemId}`, data),
  descargarEquivalencias: () => api.get('/justo/equivalencias/excel', { responseType: 'blob' }),
  subirEquivalencias: (file) => upload('/justo/equivalencias/excel', file),
  envios: (params = {}) => api.get('/justo/envios', { params }),
  pendientes: () => api.get('/justo/pendientes'),
  porPedido: (orderId) => api.get(`/justo/envios/por-pedido/${orderId}`),
  preview: (tipo, id) => api.get(`/justo/envios/${tipo}/${id}/preview`),
  exportar: (tipo, id) => api.get(`/justo/envios/${tipo}/${id}/exportar`, { responseType: 'blob' }),
  exportarZip: (envios) => api.post('/justo/envios/exportar-zip', { envios }, { responseType: 'blob' }),
  corregirOrigen: (tipo, id, warehouse_id) => api.put(`/justo/envios/${tipo}/${id}/origen`, { warehouse_id }),
  marcarSubido: (tipo, id) => api.post(`/justo/envios/${tipo}/${id}/marcar-subido`),
  desmarcarSubido: (tipo, id) => api.post(`/justo/envios/${tipo}/${id}/desmarcar-subido`),
};

export const ESTADOS_JUSTO = {
  pendiente: { label: 'Pendiente de exportar', className: 'bg-slate-100 text-slate-700' },
  modificado: { label: 'Modificado, reexportar', className: 'bg-red-100 text-red-700' },
  exportado: { label: 'Exportado', className: 'bg-amber-100 text-amber-800' },
  subido_justo: { label: 'Subido a Justo', className: 'bg-green-100 text-green-700' },
};

export const TIPO_LABEL = { dispatch: 'Despacho de pedido', shipment: 'Envío directo' };

export const blobErrorDetail = async (e) => {
  const data = e?.response?.data;
  if (data instanceof Blob) {
    try { return JSON.parse(await data.text()).detail; } catch { return null; }
  }
  return data?.detail;
};
